import React, { Component } from "react";
import { Form } from "react-bootstrap";
import debounce from "lodash-es/debounce";
import isEqual from "lodash-es/isEqual";
import { Api } from "../utils/api";
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
import EstablishmentsListTable from "./components/establishments_list_table.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import { observer } from "mobx-react";

const rowsPerPage = 50;

const EstablishmentsList = observer(
  class EstablishmentsList extends Component {
    constructor() {
      super();
      this.api = new Api();
      this.search = debounce(this.searchInitial.bind(this), 250, {
        leading: true,
      });
      this.onChange = this.onChange.bind(this);
      this.handleChangePage = this.handleChangePage.bind(this);
    }

    oldValues = null;

    componentDidMount() {
      this.search();
    }

    /**
     * Search bar
     */

    searchInitial() {
      const { query, searchValues, page } = this.props.store;
      const params = { search: query, ...searchValues };
      this.api
        .get("/establishments", {
          ...params,
          page: page + 1,
          rows: rowsPerPage,
        })
        .then(({ data: { establishments, count } }) => {
          this.props.store.setCount(count);
          this.props.store.setEstablishments(establishments);
        });
    }

    handleChangePage(event, page) {
      this.props.store.setPage(page);
      this.search();
    }

    onChange(event) {
      this.props.store.setQuery(event.target.value);
      this.search();
    }

    /**
     * Other search components
     */

    handleChange(values) {
      this.findEstablishments({
        ...values,
      });
    }

    findEstablishments(searchValues, force = false) {
      if (isEqual(searchValues, this.oldValues || {}) && !force) {
        return;
      }
      this.oldValues = searchValues;
      const { page } = this.props.store;

      this.api
        .get("/establishments", {
          ...searchValues,
          page,
        })
        .then(({ data: { establishments, count } }) => {
          this.props.store.setEstablishments(establishments);
          this.props.store.setCount(count);
        });
    }

    /**
     *
     */

    render() {
      const { establishments } = this.props.store;

      return establishments ? (
        this.renderList()
      ) : (
        <div>
          <CircularProgress color="primary" />
        </div>
      );
    }

    renderList() {
      const { establishments, count, page } = this.props.store;

      return (
        <>
          <Grid container className="m-4">
            <Form style={{ width: "39%" }}>
              <Form.Control
                type="text"
                placeholder="Pesquisa por nome ou localidade"
                onChange={this.onChange}
              />
            </Form>
          </Grid>

          <EstablishmentsListTable establishments={establishments} />

          <Grid container>
            <Grid item md={12}>
              <TablePagination
                className="pagination"
                rowsPerPageOptions={[]}
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
              />
            </Grid>
          </Grid>
        </>
      );
    }
  }
);

export default EstablishmentsList;
